import React from 'react'

import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'
import clsx from 'clsx'

import { HexagonStructure } from 'components'

import useStyles from './styles'

const QuestionnaireList = ({ questionnaires }) => {
  const classes = useStyles()

  return (
    <Box className={classes.questionnaireList}>
      {questionnaires.map((questionnaire) => {
        const completionPercentage = questionnaire?.completionPercentage ?? 0
        const isComplete = completionPercentage === 100
        const badgeLabel = `${completionPercentage}%`

        return (
          <Box
            key={questionnaire.id}
            className={clsx(
              classes.questionnaireItem,
              isComplete
                ? classes.questionnaireItemComplete
                : classes.questionnaireItemIncomplete,
            )}
          >
            <HexagonStructure
              title={`Progresso: ${completionPercentage}%`}
              display="flex"
              alignItems="center"
              justifyContent="center"
              width={44}
              height={44}
              flexShrink={0}
              className={clsx(
                classes.hexPolygon,
                isComplete ? classes.hexPolygonGreen : classes.hexPolygonBlue,
              )}
            >
              <Typography
                className={
                  isComplete
                    ? classes.hexBadgeTextLight
                    : classes.hexBadgeTextDark
                }
              >
                {badgeLabel}
              </Typography>
            </HexagonStructure>
            <Box overflow="hidden">
              <Typography variant="subtitle2" noWrap>
                {questionnaire?.questionnaire?.kind}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                Os responsáveis pelas áreas deverão responder todos os
                questionários disponibilizados.
              </Typography>
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}

QuestionnaireList.propTypes = {
  questionnaires: PropTypes.array,
}

QuestionnaireList.defaultProps = {
  questionnaires: [],
}

export default QuestionnaireList
